import React from 'react'
import { MARKER_COLORS_SALE, MARKER_COLORS_RENTAL } from './constants'
import { MarkerTemplate } from '../../Svg'
import { fixedEncodeURIComponent } from '../../../lib/utils/common'
import { DotTemplate } from '../../Svg/DotTemplate'

export const containerForLayout = layout => (
  layout === 'fixedHeight' ? (
    <div style={{ height: '450px' }} />
  ) : (
    <div style={{ height: 'calc(100vh - 148px)' }} />
  )
)

export const isActiveMarker = ({ hoveredListingId, activeItem }, { id }) => (
  hoveredListingId === id || (activeItem && activeItem.id === id)
)

const MARKER_STATUSES = {
  default: 'default',
  hover: 'hover',
  viewed: 'viewed',
  offMarket: 'offMarket',
  offMarketViewed: 'offMarketViewed'
}

const COLORS_BY_TYPE = {
  Sale: MARKER_COLORS_SALE,
  Rental: MARKER_COLORS_RENTAL,
  Land: MARKER_COLORS_SALE
}

const getMarkerStatus = (store, listing, isHoveredOnMap) => {
  const isHoveredOnListing = isActiveMarker(store, listing)

  if (isHoveredOnMap || isHoveredOnListing) { return MARKER_STATUSES.hover }
  if (listing.viewed && listing.active) { return MARKER_STATUSES.viewed }
  if (listing.viewed && !listing.active) { return MARKER_STATUSES.offMarketViewed }
  if (('active' in listing) && !listing.active) { return MARKER_STATUSES.offMarket }

  return MARKER_STATUSES.default
}

export const getFillColor = (store, listing, hovered = false) => {
  const status = getMarkerStatus(store, listing, hovered)
  return COLORS_BY_TYPE[listing.listingClass][status]
}

export const getMarkerSvgStyles = (store, listing, hovered = false) => {
  const fillColor = getFillColor(store, listing, hovered)
  return { fillColor, textColor: MARKER_COLORS_SALE.text }
}

export const buildMarkerSvgBinary = ({ store = {}, listing = {}, hovered = false }) => {
  const style = getMarkerSvgStyles(store, listing, hovered)

  const marker = listing.shortPrice
    ? MarkerTemplate({
      text: listing.shortPrice,
      tagText: listing.tagDisplay,
      style
    })
    : DotTemplate({
      fillColor: getFillColor(store, listing, hovered)
    })

  return `data:image/svg+xml;charset=utf-8,${fixedEncodeURIComponent(marker)}`
}
